module.exports = __webpack_public_path__ + "static/media/feature-interview-pass@3x.4aef0936.png";